import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Chip,
  Grid,
  Divider as MuiDivider,
  alpha,
} from '@mui/material';
import { Business as BusinessIcon } from '@mui/icons-material';

function SectorInfoCard({ sectorCode, sectorInfo }) {
  const { t } = useTranslation();
  return (
    <Card
      elevation={0}
      sx={{
        flex: 1,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 0.5,
      }}
    >
      <CardContent sx={{ p: 2.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
          <BusinessIcon sx={{ color: 'primary.main', mr: 1, fontSize: 18 }} />
          <Typography variant="subtitle2" sx={{ fontWeight: 600, fontSize: '0.875rem', letterSpacing: '0.01em', color: 'text.primary' }}>
            {t('sectorsManagement.details.sectorInfo.title')}
          </Typography>
        </Box>
        <MuiDivider sx={{ mb: 2.5, opacity: 0.2 }} />
        <Grid container spacing={2.5}>
          <Grid item xs={12}>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', mb: 0.75, display: 'block', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              {t('sectorsManagement.details.sectorInfo.sectorCode')}
            </Typography>
            <Chip
              label={sectorCode}
              size="small"
              sx={{ 
                fontWeight: 600,
                fontSize: '0.75rem',
                height: 26,
                fontFamily: 'monospace',
                letterSpacing: '0.02em',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', mb: 0.75, display: 'block', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              {t('sectorsManagement.details.sectorInfo.stockCount')}
            </Typography>
            <Typography variant="h6" sx={{ fontWeight: 600, color: 'primary.main', fontSize: '1.375rem', letterSpacing: '-0.01em' }}>
              {sectorInfo?.stock_count || 0}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', mb: 0.75, display: 'block', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>
              {t('sectorsManagement.details.sectorInfo.stockSectorCodes')}
            </Typography>
            <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap' }}>
              {sectorInfo?.stock_sector_codes?.map((code, idx) => (
                <Chip
                  key={idx}
                  label={code}
                  size="small"
                  sx={{ 
                    bgcolor: alpha('#667eea', 0.08),
                    fontSize: '0.7rem',
                    height: 24,
                    fontWeight: 400,
                    border: `1px solid ${alpha('#667eea', 0.15)}`,
                  }}
                />
              ))}
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default SectorInfoCard;

